import storageService, {
  defaultGlassSettings,
  type GlassSettings,
} from '../utils/localStorage';
import type { AppDispatch } from '../store';
import type { ReduxAction } from '../types/common';

export type { GlassSettings };
export { defaultGlassSettings };

const glassReducer = (
  state: GlassSettings = defaultGlassSettings,
  action: ReduxAction<GlassSettings>
): GlassSettings => {
  switch (action.type) {
    case 'SET_GLASS_SETTINGS':
      return action.payload ?? state;
    default:
      return state;
  }
};

// Device-local preference (like reduced motion): rendering cost varies per
// device, so this deliberately does not sync to the account.
export const setGlassSettings = (settings: GlassSettings) => {
  return (dispatch: AppDispatch) => {
    storageService.saveGlassSettings(settings);
    dispatch({ type: 'SET_GLASS_SETTINGS', payload: settings });
  };
};

export default glassReducer;
